
import * as R from 'ramda'
import { call, reducer } from '../../helpers/api/meta'
import { getCourseCategory } from '../../helpers/api/api';

export const GET_COURSES_CATEGORY = 'GET_COURSES_CATEGORY'

export const callGetCourseCategory = (inputs) => {
    const meta = {
        endpoint: (params) => getCourseCategory(params),
        inputs,
        action: GET_COURSES_CATEGORY,
        messages: {
            id: 'getCourseCategory',
            failure: 'Could not get course category detail'
        }
    }
    return call(meta)
}

const initialState = {
    loading: false,
    results: []
}

const saveCourseCategory = (state, action) => {
    return R.assoc('results', action.results, state);
}

const messages = {
    loadFailed: 'Could not load courses.',
}

export default reducer(initialState, GET_COURSES_CATEGORY, saveCourseCategory, messages.loadFailed)